<template>
    <section class="account-quick-panel">
        <div class="page-container">
            <miles-earned-component></miles-earned-component>
            <offers-claimed-chart-component></offers-claimed-chart-component>
        </div>
    </section>
</template>

<script>
import MilesEarnedComponent from "./MilesEarnedComponent.vue";
import OffersClaimedChartComponent from './OffersClaimedChartComponent.vue';
export default {
    components: {
        MilesEarnedComponent,
        OffersClaimedChartComponent,
    },
    name: "MilesAndChartComponent",
    data() {
        return {

        };
    },
    methods: {

    },
    mounted: function () {
    
    },
};
</script>
